const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1567880905822-56f8e06fe630?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxMDY4NDc1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Cafe Interior',
    span: 'col-span-2 row-span-2'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1662116765994-1e4200c43589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzaGF3YXJtYXxlbnwwfHx8fDE3NzEwNjg1MTZ8MA&ixlib=rb-4.1.0&q=85',
    alt: 'Shawarma Plate',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxmcmllc3xlbnwwfHx8fDE3NzEwNjg1Mzd8MA&ixlib=rb-4.1.0&q=85',
    alt: 'French Fries',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1531019319449-bb12b54939be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHx0ZWElMjBzaG9wfGVufDB8fHx8MTc3MTA2ODQ4M3ww&ixlib=rb-4.1.0&q=85',
    alt: 'Tea Sign',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1653542772393-71ffa417b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2ppdG98ZW58MHx8fHwxNzcxMDY4NTI5fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Mojito Drinks',
    span: 'col-span-1 row-span-1'
  }
];

export const GallerySection = () => {
  return (
    <section className="section-padding bg-muted/30">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Our Gallery
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            A glimpse into our delicious world
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className={`relative overflow-hidden rounded-2xl group ${image.span}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;